import { FormInstance } from "antd";
import { createContext } from "react";

export const TicketSaveFormInstanceContext = createContext<FormInstance | null>(
  null
);
export const TicketSaveFormInstanceProvider =
  TicketSaveFormInstanceContext.Provider;
